import type { BriefGateway, SubmissionReceipt } from '@/application/brief/BriefGateway';
import type { Brief } from '@/domain/brief/Brief';

/**
 * Passerelle de développement : simule la latence réseau tant que l'API Go
 * n'existe pas. Elle ne transmet rien.
 */
export class SimulatedBriefGateway implements BriefGateway {
  private readonly latencyMs: number;

  constructor(latencyMs = 1200) {
    this.latencyMs = latencyMs;
  }

  async submit(_brief: Brief, signal?: AbortSignal): Promise<SubmissionReceipt> {
    await new Promise<void>((resolve, reject) => {
      const timer = window.setTimeout(resolve, this.latencyMs);
      signal?.addEventListener('abort', () => {
        window.clearTimeout(timer);
        reject(signal.reason instanceof Error ? signal.reason : new Error('aborted'));
      });
    });
    return {
      reference: `OX-${crypto.randomUUID().slice(0, 8).toUpperCase()}`,
      receivedAt: new Date(),
    };
  }
}
